import { render, staticRenderFns } from "./MaptmHeader.vue?vue&type=template&id=0dff2f14&"
import script from "./MaptmHeader.vue?vue&type=script&lang=js&"
export * from "./MaptmHeader.vue?vue&type=script&lang=js&"
import style0 from "./MaptmHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports